import React, {Component} from "react";
import {
    FormSection,
    Link,
    SectionBody,
    SectionFooter,
    SectionFooterPrimaryContent,
} from "aws-amplify-react/dist/Amplify-UI/Amplify-UI-Components-React";
import {I18n} from "aws-amplify";
import * as PropTypes from "prop-types";
import {STYLE_LINK} from "../Styles/style";
import {GeneLifeDict} from "../translate/GeneLife";
import Header from "./parts/Header";
import Footer from "./parts/Footer";
import '../Styles/genelife.css';
import '../Styles/subpages.css';

I18n.setLanguage('ja-JP');
I18n.putVocabularies(GeneLifeDict);

export class SignOutComponent extends Component {
    render() {
        return(<div>
          <div className="content_wrapper">
            <div className="area_usual">
              <div className="container">

                {this.props.signOut()}
                <Header/>
                <FormSection theme={this.props.theme}>
                <SectionBody theme={this.props.theme}>
                    {I18n.get(this.props.msg)}
                </SectionBody>
                <SectionFooter theme={this.props.theme}>
                    <SectionFooterPrimaryContent theme={this.props.theme}>
                        <Link theme={this.props.theme}  style={STYLE_LINK} onClick={this.props.changeStateFunc}>
                            {I18n.get("ログイン画面へ戻る")}
                        </Link>
                    </SectionFooterPrimaryContent>
                </SectionFooter>
                </FormSection>
                </div>
                </div>
            </div>
            <Footer/>
            </div>
        )
    }
}

SignOutComponent.propTypes = {
    theme: PropTypes.any,
    changeStateFunc: PropTypes.func,
    msg: PropTypes.string,
    signOut: PropTypes.func
}
